import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { hideModal } from '../../../../actions/_modal'
import Modal from '../../../mini/Modal'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import Checkbox from '../../../mini/Checkbox'
import {
  DeleteModalWrapper,
  DeleteCancelButton,
  DeleteButton,
  DeleteDivider,
  TrashIcon,
  H3Delete
} from './styled'
import useLexicon from '../../../../hooks/useLexicon'

const DeleteResource = ({ onDelete }) => {
  const [applyToAllSections, setApplyToAllSections] = useState(true)
  const dispatch = useDispatch()
  const lexicon = useLexicon()

  const closeTheModal = () => {
    dispatch(hideModal())
  }

  const onDeleteClick = () => {
    onDelete(applyToAllSections)
    closeTheModal()
  }

  return (
    <Modal opacity={'1'}>
      <DeleteModalWrapper>
        <TrashIcon />
        <H3Delete>Are you sure you want to delete this {lexicon.resource}?</H3Delete>

        <p className="p2">Once deleted, this cannot be undone.</p>

        <DeleteDivider />

        <FlexAlignCenter
          style={{
            justifyContent: 'space-between',
            margin: '0 22px'
          }}
        >
          <FlexAlignCenter>
            <Checkbox
              checked={applyToAllSections}
              onChange={e => {
                setApplyToAllSections(e.target.checked)
              }}
            />
            <div
              style={{ display: 'inline', cursor: 'pointer' }}
              className="caption4"
              onClick={e => {
                setApplyToAllSections(!applyToAllSections)
              }}
            >
              Delete from all my {lexicon.section}s.
            </div>
          </FlexAlignCenter>

          <div>
            <DeleteCancelButton onClick={closeTheModal}>
              Cancel
            </DeleteCancelButton>
            <DeleteButton onClick={onDeleteClick}>Delete</DeleteButton>
          </div>
        </FlexAlignCenter>
      </DeleteModalWrapper>
    </Modal>
  )
}

export default DeleteResource
